import * as React from "react";

import { cn } from "~/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
	return (
		<input
			className={cn(
				"flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
				className
			)}
			type={type}
			{...props}
		/>
	);
}
Input.displayName = "Input";

export function InputWithPrefix({ className, prefix, ...props }: { prefix: React.ReactNode } & React.ComponentProps<"input">) {
	return (
		<div className="flex rounded-md ring-offset-background focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2">
			<div className="shrink-0 rounded-l-md border border-r-0 border-input bg-background px-3 py-2 pr-1 md:text-sm">
				{prefix}
			</div>
			<Input className="h-full rounded-l-none border-l-0 pl-0 focus-visible:border-l-0 focus-visible:ring-0" {...props} type="number" />
		</div>
	);
}

export { Input };
